import React, { useState, useEffect } from 'react';
import './FloatingCTA.css';

const FloatingCTA = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      const hero = document.getElementById('hero');
      const contact = document.getElementById('contact');
      const heroHeight = hero ? hero.offsetHeight : 400;
      const contactTop = contact ? contact.offsetTop : document.body.scrollHeight;

      if (window.scrollY > heroHeight && window.scrollY + window.innerHeight < contactTop) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  return (
    <div className={`floating-cta-container ${isVisible ? 'visible' : ''}`}>
      <a href="tel:+13107217974" className="btn btn-orange">Call Us</a>
      <a href="#contact" className="btn btn-orange">Book Now</a>
    </div>
  );
};

export default FloatingCTA;
